import { createReducer, on } from '@ngrx/store';
import {StateStatus} from "../../../shared/models/state-status.models";
import {
  createBlobContainer,
  createBlobContainerFailure,
  createBlobContainerSuccess,
  createDefaultRoles, createDefaultRolesFailure,
  createDefaultRolesSuccess,
  createTenant,
  createTenantFailure,
  createTenantSuccess,
  getAllTenants,
  getAllTenantsFailure,
  getAllTenantsSuccess, reCreateDefaultRoles, reCreateDefaultRolesFailure, reCreateDefaultRolesSuccess
} from "./tenant.action";
import {Tenant} from "../../../shared/models/tenant.model";

export interface TenantState {
  tenants: Tenant[];
  error: string | null;
  status: StateStatus;
  createTenantStatus: StateStatus;
  createBlobContainerStatus: StateStatus;
  createDefaultRolesStatus: StateStatus;
  createTenantError: string | null;
  createBlobContainerError: string | null;
  createDefaultRolesError: string | null;
}

export const initialState: TenantState = {
  tenants: [],
  error: null,
  status: 'pending' as StateStatus,
  createTenantStatus: 'pending' as StateStatus,
  createBlobContainerStatus: 'pending' as StateStatus,
  createDefaultRolesStatus: 'pending' as StateStatus,
  createTenantError: null,
  createBlobContainerError: null,
  createDefaultRolesError: null,
};

export const tenantReducer = createReducer(
  initialState,
  on(getAllTenants, (state): TenantState => ({ ...state, status: 'loading' as StateStatus })),
  on(getAllTenantsSuccess, (state, { tenants }): TenantState => ({
    ...state,
    tenants: tenants,
    error: null,
    status: 'loadSuccess' as StateStatus,
  })),
  on(getAllTenantsFailure, (state, { error }): TenantState => ({
    ...state,
    error: error,
    status: 'error' as StateStatus,
  })),

  on(createTenant, (state): TenantState => ({
    ...state,
    createTenantStatus: 'adding' as StateStatus,
    createTenantError: null
  })),
  on(createTenantFailure, (state, { error }) : TenantState => ({
    ...state,
    createTenantError: error,
    createTenantStatus: 'error' as StateStatus,
  })),
  on(createTenantSuccess, (state, { tenant }): TenantState => ({
    ...state,
    tenants: [tenant, ...state.tenants],
    createTenantStatus: 'addSuccess' as StateStatus,
  })),

  on(createBlobContainer, (state, { tenant }): TenantState => ({
    ...state,
    tenants: [tenant, ...state.tenants],
    createBlobContainerStatus: 'adding' as StateStatus,
    createBlobContainerError: null
  })),
  on(createBlobContainerSuccess, (state, { tenant }): TenantState => ({
    ...state,
    error: null,
    createBlobContainerStatus: 'addSuccess' as StateStatus,
  })),
  on(createBlobContainerFailure, (state, { error }): TenantState => ({
    ...state,
    error: error,
    createBlobContainerStatus: 'error' as StateStatus,
    createBlobContainerError: error
  })),

  on(createDefaultRoles, (state, { tenant }): TenantState => ({
    ...state,
    createDefaultRolesError: null,
    createDefaultRolesStatus: 'adding' as StateStatus,
  })),
  on(createDefaultRolesSuccess, (state, { tenant }): TenantState => ({
    ...state,
    createDefaultRolesError: null,
    createDefaultRolesStatus: 'addSuccess' as StateStatus,
  })),
  on(createDefaultRolesFailure, (state, { error }): TenantState => ({
    ...state,
    createDefaultRolesError: error,
    createDefaultRolesStatus: 'error' as StateStatus,
  })),


  on(reCreateDefaultRoles, (state, { tenant }): TenantState => ({
    ...state,
    error: null,
    status: 'adding' as StateStatus,
  })),
  on(reCreateDefaultRolesSuccess, (state, { tenant }): TenantState => ({
    ...state,
    error: null,
    status: 'addSuccess' as StateStatus,
  })),
  on(reCreateDefaultRolesFailure, (state, { error }): TenantState => ({
    ...state,
    error: error,
    status: 'error' as StateStatus,
  })),

);

